import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, NgModule, OnInit } from '@angular/core';
import { Cms } from '@impact/data';
import { TranslateModule } from '@ngx-translate/core';
import { starIcon } from '../../../icons';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { UtilsModule } from '../../utils/utils.module';

@Component({
    selector: 'app-reviews-spot',
    template: `
        <div class="reviews-spot" *ngIf="data?.reviews">
            <app-rich-text *ngIf="data?.reviewsText" [html]="data?.reviewsText"></app-rich-text>
            <ul class="reviews-spot__list">
                <li class="reviews-spot__item" *ngFor="let item of data?.reviews">
                    <div class="reviews-spot__item-image">
                        <img [src]="item?.reviewSource?.sourceLogo?.src | resolveMediaUrl: { format: 'webp', width: 150 }" loading="lazy" />
                    </div>
                    <div class="reviews-spot__item-text">"{{item?.introText}}"</div>

                    <div [ngSwitch]="['1', '2', '3', '4', '5', '6'].includes(item?.reviewRating ?? '')">
                        <ng-container *ngSwitchCase="true">
                            <div class="reviews-spot__item-rating"
                                [class]="'reviews-spot__item-rating--' + item?.reviewRating">
                                <div class="rating-star">${starIcon}</div>
                                <div class="rating-star">${starIcon}</div>
                                <div class="rating-star">${starIcon}</div>
                                <div class="rating-star">${starIcon}</div>
                                <div class="rating-star">${starIcon}</div>
                                <div class="rating-star">${starIcon}</div>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="false"> {{'reviews.no_rating_text' | translate}}</ng-container>
                    </div>

                    <div class="reviews-spot__item-link">
                        <a [href]="item?.reviewUrl" target="_blank" class="button--primary button--themed reviews-button">
                            {{'reviews.read_review_button_text' | translate}}
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    `
})

class ReviewsSpotComponent implements OnInit {

    @Input() data: Cms.ReviewsSpot;

    constructor( private cdr: ChangeDetectorRef ) {}

    ngOnInit() {
        this.cdr.markForCheck();
    }
}

@NgModule({
    declarations: [ReviewsSpotComponent],
    imports: [
        CommonModule,
        RichTextModule,
        UtilsModule,
        TranslateModule.forChild()
    ]
})
class ReviewsSpotModule {}

export const LazySpotComponent = ReviewsSpotComponent;
